
import i18n from '../../i18n/i18n.js';
import './NoPage.css';

const NoPage = () => {
  return <div className={`container page_no_page no-animation`}>
      <div className="content">
        <div className='container_inner'>
            <h1 className="page_title">404</h1>
            <div className="page_content" dangerouslySetInnerHTML={{__html: i18n.t('404Text')}}></div>
          </div>
      </div>
    </div>;
};

export default NoPage; 